/**
 * Following the duck pattern, actions, constants and reducers are in the same file called module.js
 *
 * See: https://github.com/erikras/ducks-modular-redux
 *
 */

import { takeEvery } from 'redux-saga/effects'

import { getTutorial } from 'modules/generators/getTutorialGenerator'

export const GET_TUTORIEL_REQUEST = 'Tutoriel/GET_TUTORIEL_REQUEST'
export const GET_TUTORIEL_SUCCESS = 'Tutoriel/GET_TUTORIEL_SUCCESS'
export const GET_TUTORIEL_ERROR = 'Tutoriel/GET_TUTORIEL_ERROR'

export function getTutorielRequest (id) {
  return {
    type: GET_TUTORIEL_REQUEST,
    payload: id
  }
}

export function getTutorielSuccess (tutoriel) {
  return {
    type: GET_TUTORIEL_SUCCESS,
    payload: tutoriel
  }
}

export function getTutorielError (error) {
  return {
    type: GET_TUTORIEL_ERROR,
    payload: error
  }
}

export function * getTutorielSaga () {
  yield takeEvery(GET_TUTORIEL_REQUEST, getTutorial, getTutorielSuccess, getTutorielError)
}

const initialState = {
  tutoriel: null,
  error: null
}

/**
 * Following the duck pattern, the module.js file should export a reducer as a default function
 */
export function reducer (state = initialState, action) {
  switch (action.type) {
    case GET_TUTORIEL_REQUEST:
      return {
        ...state,
        tutoriel: null,
        error: null
      }
    case GET_TUTORIEL_SUCCESS:
      return {
        ...state,
        tutoriel: action.payload
      }
    case GET_TUTORIEL_ERROR:
      return {
        ...state,
        error: action.payload
      }
    default:
      return state
  }
}

export default reducer
